import YesNoQuestionPage from "@components/YesNoQuestionPage"

export default function LooksmaxxingExperimentingLookPage() {
  return <YesNoQuestionPage translationKey="experimentingLookLooksmaxxing" />
}
